import { WithChildrenCommonProps } from '@shipengine/giger';

import { getSidePanelFooterStyles } from './SidePanelFooterStyles';

export const SidePanelFooter = ({ children, ...rest }: WithChildrenCommonProps<unknown>): JSX.Element => (
    <footer {...rest} css={getSidePanelFooterStyles}>
        {children}
    </footer>
);
